(() => {
  const button = document.querySelector('[data-menu-toggle]');
  const panel = document.querySelector('[data-mobile-menu]');

  if (button && panel) {
    const closeMenu = () => {
      button.setAttribute('aria-expanded', 'false');
      panel.hidden = true;
      document.body.classList.remove('menu-open');
    };

    button.addEventListener('click', () => {
      const isOpen = button.getAttribute('aria-expanded') === 'true';
      button.setAttribute('aria-expanded', String(!isOpen));
      panel.hidden = isOpen;
      document.body.classList.toggle('menu-open', !isOpen);
    });

    panel.querySelectorAll('a').forEach((link) => link.addEventListener('click', closeMenu));

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') closeMenu();
    });
  }

  document.querySelectorAll('[data-quantity-change]').forEach((buttonElement) => {
    buttonElement.addEventListener('click', () => {
      const input = document.getElementById(buttonElement.getAttribute('aria-controls'));
      if (!input) return;
      const direction = Number(buttonElement.dataset.quantityChange);
      const minimum = Number(input.min || 0);
      input.value = Math.max(minimum, Number(input.value || 0) + direction);
    });
  });
})();
